export class RUDetailedLocation
{
	rUDetailedLocationId: number;
	rUDetailedLocationDate: Date;
}
